var _defs, _circle, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTestlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.53 26.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-testlink-1 {\n        fill: #fff !important;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.26,
    cy: 13.26,
    r: 13.26
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-testlink-1",
    points: "9.81 19.06 17.96 13.26 9.81 7.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestlink);
export default __webpack_public_path__ + "static/media/icon_testlink.90712d21ee16bed680c9d92826396440.svg";
export { ForwardRef as ReactComponent };